import Catalog from '@/page/Catalog.vue'
import CatalogMenu from '@/page/CatalogMenu.vue'
import CatalogMenuName from '@/page/CatalogMenuName.vue'
import Login from '@/page/Login.vue'
import Search from '@/page/Search.vue'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/catalog-menu',
    name: 'catalogMenu',
    component: CatalogMenu
  },
  {
    path: '/catalog-menu/:name',
    name: 'catalogMenuName',
    component: CatalogMenuName
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/catalog/:name',
    name: 'catalog',
    component: Catalog
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
